@if (authenticated) {
  <router-outlet></router-outlet>
} @else {
  <cg-loading />
}
